import { useCallback } from 'react';
import { fieldMappingService } from '../services';
import { Project } from '~/src/entities/project/types';

interface UseBulkApproveMappingsProps {
  orgFprint: string;
  projectId: number;
  projectData: Project | null;
  isAIFieldMapperEnabled: boolean;
}

export const useBulkApproveMappings = ({
  orgFprint,
  projectId,
  projectData,
  isAIFieldMapperEnabled,
}: UseBulkApproveMappingsProps) => {
  const approveMappings = useCallback(async () => {
    if (!isAIFieldMapperEnabled || !projectData) {
      return;
    }

    // We are filtering this way in the backend as well but this avoids making the API call at all if none are AI Generated
    const aiGeneratedMappingIds = projectData.stack_data.fields
      .filter(
        (f) =>
          f.field_mapping_metadata?.status === 'ai_generated' &&
          f.field_mapping_metadata?.field_mapping_id,
      )
      .map((f) => f.field_mapping_metadata!.field_mapping_id);

    if (aiGeneratedMappingIds.length > 0) {
      await fieldMappingService.bulkApprove(
        orgFprint,
        projectId,
        aiGeneratedMappingIds,
      );
    }
  }, [orgFprint, projectId, projectData, isAIFieldMapperEnabled]);

  return { approveMappings };
};
